/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix accessibility

import { FC, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AppReportProblemButtonComponent } from '../../../../components/app-report-problem-modal/app-report-problem-button.component';
import {
  ExportButtonComponent,
  getFileName,
} from '../../../../components/reports/components/export-button/export-button.component';
import { ShareButtonComponent } from '../../../../components/reports/components/share-button/share-button.component';
import { REPORT_NAMES } from '../../../../components/reports/constants/report-names.constants';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { ScenarioPlannerExtended } from '../../../../hooks/scenario-planner/scenario-planner.interface';
import { useScenarioPlannerCloneHandler } from '../../../../hooks/scenario-planner/use-scenario-planner-clone-handler.hook';
import { IMAGES_REPO } from '../../../../static-resources/home-image-repo';
import CopyScenarioModal from '../copy-scenario-modal/copy-scenario.modal';
import './scenario-header.component.scss';

interface ScenarioHeaderComponentProps {
  onDuplicate: () => void;
  onExport: () => void;
  onShare: () => void;
  isViewOnly: boolean;
  scenarioPlanner?: ScenarioPlannerExtended;
  filterSelection: FilterSelectedValue[];
}

const copyOfText = 'Copy of ';
const ScenarioHeaderComponent: FC<ScenarioHeaderComponentProps> = ({
  onDuplicate,
  isViewOnly,
  scenarioPlanner,
  filterSelection,
}) => {
  const { showCopyModal, setShowCopyModal, handleCloneScenario } =
    useScenarioPlannerCloneHandler(
      scenarioPlanner?.id || '',
      scenarioPlanner?.shareKey || '',
    );
  const navigate = useNavigate();

  const defaultScenarioName = useMemo(() => {
    const name = scenarioPlanner?.name?.trim() || '';
    const newName = name.substring(0, 256 - copyOfText.length);
    return `${copyOfText}${newName}`;
  }, [scenarioPlanner]);

  return (
    <div className="scenario-top-header-container">
      <div className="scenario-header-left">
        <Link to="/" className="scenario-header-title">
          <img src={IMAGES_REPO.HomeLineIcon} alt="Home" /> IRIS Home
          <span className="breadcrumb-arrow">{'>'}</span>
        </Link>

        <Link to="/t/s?nav=0" className="scenario-header-title">
          Price & Promo Simulator Home
          <span className="breadcrumb-arrow">{'>'}</span>
        </Link>

        <span className="scenario-header-title active">Plan</span>
      </div>

      {/* View-only message */}
      <div className="scenario-header-message">
        {isViewOnly && (
          <div className="view-only-message">
            <span className="dot" />
            This is a view only version of a scenario click
            <span className="copy-link" onClick={() => setShowCopyModal(true)}>
              here
            </span>
            to create a copy
          </div>
        )}
      </div>
      {/* Actions */}
      <div className="scenario-header-actions">
        <Button
          variant="default"
          className="btn-default-blue navigation-button"
          onClick={() => {
            if (!isViewOnly) {
              navigate({ pathname: '/t/r', search: '?nav=0&ref=1' });
            }
          }}
          disabled={isViewOnly}
        >
          <img
            className="icon-blue"
            src={IMAGES_REPO.LinkExternal}
            alt="Demand Modal"
          />
          Demand Model
        </Button>
        <Button
          variant="default"
          className="btn-default-blue navigation-button"
          onClick={() => {
            if (!isViewOnly) {
              navigate({ pathname: '/t/i', search: '?nav=0&ref=1' });
            }
          }}
          disabled={isViewOnly}
        >
          <img
            className="icon-blue"
            src={IMAGES_REPO.LinkExternal}
            alt="Decomp Insights"
          />
          Decomp Insights
        </Button>
        <Button
          variant="default"
          className="btn-default-black navigation-button"
          onClick={() => {
            onDuplicate(); // optional: for analytics/logging
            setShowCopyModal(true); // <-- open the modal
          }}
          disabled={isViewOnly}
        >
          <img src={IMAGES_REPO.CopyIcon} alt="Copy" /> Duplicate
        </Button>
        <AppReportProblemButtonComponent />
        <ExportButtonComponent
          reportName={`${REPORT_NAMES.SCENARIO_PLANNER_SUMMARY_MANUFACTURER},${REPORT_NAMES.SCENARIO_PLANNER_SUMMARY_BRAND},${REPORT_NAMES.SCENARIO_PLANNER_SUMMARY_SUBBRAND},${REPORT_NAMES.SCENARIO_PLANNER_SUMMARY_PACK},${REPORT_NAMES.SCENARIO_PLANNER_SCENARIO_SUMMARY},${REPORT_NAMES.SCENARIO_PLANNER_DATA},${REPORT_NAMES.SCENARIO_PLANNER_PPG_SUMMARY_REPORT},${REPORT_NAMES.SCENARIO_PLANNER_DETAILS_REPORT}`}
          filterSelection={filterSelection}
          filename={getFileName(scenarioPlanner?.name)}
          reportId={`${scenarioPlanner?.id}`} // No need to pass report id for each report name. It will use the same for all if number of report ids don't match with numbers of report names.
        />
        <ShareButtonComponent filterSelection={filterSelection} />
      </div>

      {/* Modal */}
      <CopyScenarioModal
        defaultScenarioName={defaultScenarioName}
        show={showCopyModal}
        setShow={setShowCopyModal}
        onCopy={handleCloneScenario}
      />
    </div>
  );
};

export default ScenarioHeaderComponent;
